import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

type ErrorFallbackProps = {
    errorMessage?: string;
};

const ErrorFallback = ({ errorMessage }: ErrorFallbackProps) => (
    <ErrorState
        outerClassName='margin-top-20'
        headline='Oh snap! Something went wrong.'
        message={
            <>
                We could not load your data. Please try again.
                {errorMessage && <div className='margin-top-15 text-color-dark'>{errorMessage}</div>}
            </>
        }
    />
);

export default ErrorFallback;
